module.exports = __webpack_public_path__ + "static/img/taiHeImg1.417c931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taiHeImg1.png
// module id = TSRs
// module chunks = 2